import { AppUseSelector } from '../redux/hooks'
import { characterConst } from '../utils/constant'

/**
 * The `lang` for Chinese text. Every element that shows Chinese carries it, so a Japanese or
 * Korean interface never draws hanzi with Japanese or Korean glyph shapes. Traditional mode is the
 * learner's `character` setting.
 */
export const chineseLang = (character?: string | null): 'zh-Hans' | 'zh-Hant' =>
  character === characterConst.traditional ? 'zh-Hant' : 'zh-Hans'

/** chineseLang for the signed-in learner's character setting. */
export const useChineseLang = () =>
  chineseLang(AppUseSelector((state: any) => state.user?.credentials?.customFields?.character))
